import React from 'react';
import { FormField } from 'taboola-ultimate-ui';
import { OutlineEditableText } from 'modules/campaigns/components/OutlineEditableText/OutlineEditableText';
import { withIndication } from 'modules/errors';
import { FormattedMessage, useIntl } from 'modules/taboola-common-frontend-modules/i18n';
import { useFormValidatedValue, validationFunctions } from 'modules/taboola-common-frontend-modules/validations';
import styles from './subscriptionEndpointField.module.scss';

const OutlineEditableTextWithIndication = withIndication(OutlineEditableText);
const validations = [
    {
        validationFn: validationFunctions.isURL,
        messageId: 'push-api.subscription.validations.error.endpoint.url',
        defaultMessage: 'Please enter a valid URL',
    },
];

export const SubscriptionEndpointField = () => {
    const {
        value: endpointUrl,
        onChange: onEndpointChange,
        indicationData,
    } = useFormValidatedValue({
        field: 'endpointUrl',
        validations,
    });

    const { formatMessage } = useIntl();
    const placeholder = formatMessage({
        id: `push-api.subscription.endpoint.placeholder`,
        defaultMessage: 'Type endpoint here...',
    });

    return (
        <FormField
            inputId="subscription-endpoint-input"
            containerClass={styles['input-container']}
            label={<FormattedMessage id="push-api.subscription.endpoint.title" defaultMessage="Endpoint" />}
        >
            <OutlineEditableTextWithIndication
                id="endpoint"
                value={endpointUrl}
                onChange={onEndpointChange}
                placeholder={placeholder}
                {...indicationData}
            />
        </FormField>
    );
};
